import React, { Component } from 'react'

class SettingCategoryTab extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentTabId: this.props.defaultTab
    }
  }
  onClick (tabId) {
    this.setState({
      currentTabId: tabId
    })
    if (this.props.onClick) {
      this.props.onClick(tabId)
    }
  }
  render () {
    const tabList = [
      {id: 'GetsugakuSetting', title: '標準報酬月額'},
      {id: 'NenkinSetting', title: '厚生年金'},
      {id: 'KenkouSetting', title: '健康保険'},
      {id: 'KaigoSetting', title: '介護保険'},
      {id: 'KodomoSetting', title: '子ども・子育て拠出金'},
      {id: 'KoyouSetting', title: '雇用保険'},
      {id: 'SekkeiUnitPriceSetting', title: '設計労務単価'},
      {id: 'UchiwakeSetting', title: '工事内訳項目'}
    ]
    const tabListToShow = tabList.map(tab => {
      const activeClass = (this.state.currentTabId === tab.id) ? 'active' : ''
      return (
        <li key={tab.id} className={activeClass} >
          <a onClick={this.onClick.bind(this, tab.id)}>{tab.title}</a>
        </li>
      )
    })
    return (
      <ul className='nav nav-tabs'>
        {tabListToShow}
      </ul>
    )
  }
}
SettingCategoryTab.defaultProps = {defaultTab: 'GetsugakuSetting', onClick: null}
export default SettingCategoryTab



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/SettingCategoryTab.js